<form>
  <ng-container *transloco="let t; read: 'ime.common.classificators'">
    <div class="card">
      <div class="card-body">
        <div class="form-group row">
          <label for="code" class="col-sm-4 col-form-label">{{ t('Code') }}</label>
          <div class="col-sm-8">
            <input type="text" class="form-control" id="code" name="code" [(ngModel)]="classificator.Code">
          </div>
        </div>
        <div class="form-group row">
          <label for="name" class="col-sm-4 col-form-label">{{t('Name')}}</label>
          <div class="col-sm-8">
            <input type="text" class="form-control" id="name" name="name" [(ngModel)]="classificator.Name">
          </div>
        </div>
        <div class="form-group row">
          <label for="type" class="col-sm-4 col-form-label">{{t('Type')}}</label>
          <div class="col-sm-8">
            <mes-web-classificator-value-select [items$]="classificatorTypes$" [entityId]="classificator.TypeClv" (entityIdChange)="classificator.TypeClv = $event" name="type" id="type"></mes-web-classificator-value-select>
          </div>
        </div>
        <div class="form-group row">
          <label for="IsParent" class="col-4 col-form-label">{{t('Parent')}}</label>
          <div class="col-8">
            <div class="form-check">
              <input type="checkbox" class="form-check-input position-static" [(ngModel)]="classificator.IsParent" name="IsParent" id="IsParent">
            </div>
          </div>
        </div>
        <div class="form-group row" *ngIf="classificator.IsParent">
          <label for="Parent" class="col-4 col-form-label">{{t('Parent')}}</label>
          <div class="col-8">
            <mes-web-classificator-select [items$]="classificatorsQuery.loadAll()" [entityId]="classificator.ParentId" (entityIdChange)="classificator.ParentId = $event" name="Parent" id="Parent"></mes-web-classificator-select>
          </div>
        </div>
        <div class="form-group row">
          <label for="comment" class="col-sm-4 col-form-label">{{t('Comment')}}</label>
          <div class="col-sm-8">
            <textarea class="form-control" name="comment" id="comment" [(ngModel)]="classificator.Comment"></textarea>
          </div>
        </div>
      </div>
    </div>

    <div class="card mt-2">
      <div class="card-body">
        <h5 class="card-title pb-1">{{t('Values')}}</h5>
        <p-table styleClass="p-datatable-sm" [value]="classificator.Values" dataKey="Id">
          <ng-template pTemplate="header">
            <tr>
              <th class="w-25 pe-1">{{t('Code')}}</th>
              <th class="w-25 pe-1">{{t('Value')}}</th>
              <th [class.wx-48]="classificator.TypeClv === classificators.ClassificatorType.Json">{{t('Data')}}</th>
              <th class="pe-1">{{t('Comment')}}</th>
              <th class="pe-1 wx-80">{{t('Sequence')}}</th>
              <th class="pe-1 wx-80">{{t('Default')}}</th>
              <th class="pe-1 wx-80">{{t('Disabled')}}</th>
              <th class="wx-48" *ngIf="!classificator.IsSystem"></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr>
              <td>
                <input name="Code-{{row.Id}}" type="text" class="form-control" [(ngModel)]="row.Code">
              </td>
              <td>
                <input name="Value-{{row.Id}}" type="text" class="form-control" [(ngModel)]="row.Value">
              </td>
              <td>
                <button type="button" class="btn btn-outline-primary btn-sm" (click)="editData(row)" *ngIf="classificator.TypeClv === classificators.ClassificatorType.Json; else textareaTmpl">
                  <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#pencil"></svg>
                </button>
                <ng-template #textareaTmpl>
                  <textarea class="form-control" name="data-{{row.Id}}" [(ngModel)]="row.Data"></textarea>
                </ng-template>
              </td>
              <td>
                <textarea class="form-control" name="Comment-{{row.Id}}" [(ngModel)]="row.Comment"></textarea>
              </td>
              <td>
                <input name="Sequence-{{row.Id}}" type="number" class="form-control" [(ngModel)]="row.Sequence">
              </td>
              <td>
                <div class="form-check">
                  <input name="IsDefault-{{row.Id}}" type="checkbox" class="form-check-input position-static" [(ngModel)]="row.IsDefault">
                </div>
              </td>
              <td>
                <div class="form-check">
                  <input name="IsDisabled-{{row.Id}}" type="checkbox" class="form-check-input position-static" [(ngModel)]="row.IsDisabled">
                </div>
              </td>
              <td *ngIf="!classificator.IsSystem">
                <button type="button" class="btn btn-sm btn-outline-danger" (click)="removeValue(row)">
                  <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#trash"></svg>
                </button>
              </td>
            </tr>
          </ng-template>
        </p-table>
        <footer class="row">
          <div class="col text-end">
            <button type="button" class="btn btn-sm btn-outline-primary mt-1" (click)="addValue()">
              <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#plus"></svg>
              {{t('Add Value')}}
            </button>
          </div>
        </footer>
      </div>
    </div>
  </ng-container>
</form>

